export const SUPPORTED_INFERENCE_ADDRESSES = {
  Precompile: '0x00000000000000000000000000000000000000F4',
  InferenceHub: '0x8383C9bD7462F12Eb996DD02F78234C0421A6FaE',
  LLMInference: '0xf1dc0d5Dcf2A01924faC78185B9227CF3EC839A5',
} as const;
